import React from 'react';
import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';
import { Dispatch } from 'redux';
import { AppState, CustomerContact, Menu } from 'acscp/store';
import { CustomerContactDetailsRequest } from 'acscp/api/requests';
import { FetchRequest, SetOpenMenu } from 'acscp/actions';
import { SideScreen } from 'acscp/components/common/sideScreen';
import style from 'acscp/components/common/sideScreen.module.scss';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { connectWithRequests } from 'acscp/store/helpers/connectWithRequests';
import { CrossIcon } from 'acscp/components/common/icons/crossIcon';
import { LogoutButton } from './logoutButton';
import { userCanAccessCharters } from 'acscp/store/helpers/authHelper';

interface CustomerContactDetailsStateProps {
    customerContact?: CustomerContact;
    isOpen: boolean;
    canAccessCharters: boolean;
}

interface CustomerContactDetailsDispatchProps {
    fetchCustomerContactDetails: () => void;
    closeMenu: () => void;
    openAccountPreferencesMenu: () => void;
}

export class CustomerContactDetailsPresentational extends PresentationComponentBase<{},
    CustomerContactDetailsStateProps, CustomerContactDetailsDispatchProps, {}> {

    componentDidUpdate(propsPrev: CustomerContactDetailsStateProps, statePrev: {}): void {
        if (this.props.isOpen && !propsPrev.isOpen) {
            this.props.fetchCustomerContactDetails();
        }
    }

    render(): JSX.Element | null {
        const { customerContact, isOpen, closeMenu, canAccessCharters } = this.props;
        if (isOpen && customerContact !== undefined) {
            return (
                <SideScreen>
                    <div className={style.BlueHeader}>
                        <FormattedMessage
                            id={'components.customerContactDetails.myAccount'}
                            defaultMessage={'My Account'}
                        />
                        <a href="javascript:;" id="Exit" onClick={closeMenu} aria-label="Close">
                            <CrossIcon />
                        </a>
                    </div>
                    <div className={classNames(style.MediumItem, style.WithBorder)}>
                        <FormattedMessage
                                id={'components.customerContactDetails.myDetails'}
                                defaultMessage={'MY DETAILS'}
                        />
                    </div>
                    <div className={style.LargeItem}>
                        {customerContact.contactName}
                    </div>
                    <div className={style.SmallItem}>
                        <FormattedMessage
                            id={'components.customerContactDetails.landline'}
                            defaultMessage={'Landline'}
                        />: <span className={style.Info}>{customerContact.telephoneNumber}</span></div>
                    <div className={style.SmallItem}>
                        <FormattedMessage
                            id={'components.customerContactDetails.mobile'}
                            defaultMessage={'Mobile'}
                        />: <span className={style.Info}>{customerContact.mobileNumber}</span></div>
                    <div className={style.SmallItem}>
                        <FormattedMessage
                            id={'components.customerContactDetails.email'}
                            defaultMessage={'Email'}
                        />: <span className={style.Info}>{customerContact.email}</span></div>
                    <div className={classNames(style.SmallItem, style.WithMediumItemBottomSpacing)}>
                        <FormattedMessage
                            id={'components.customerContactDetails.accountId'}
                            defaultMessage={'Account ID'}
                        />: <span className={style.Info}>{customerContact.accountId}</span></div>
                    {ENABLE_CREATE_ACCOUNT && canAccessCharters &&
                        <div
                            className={classNames(style.MediumItem, style.WithBorder, style.ItemWithLink)}
                            onClick={this.props.openAccountPreferencesMenu}
                        >
                            <FormattedMessage
                                id={'components.customerContactDetails.accountPreferences'}
                                defaultMessage={'Account Preferences'}
                            />
                        </div>}
                    <div className={classNames(style.MediumItem, style.WithBorder, style.HiddenOnMobile)}>
                        <LogoutButton/>
                    </div>
                </SideScreen>
            );
        } else {
            return (
                null
            );
        }
    }
}

function mapStateToProps(state: AppState, ownProps: {}): CustomerContactDetailsStateProps {
    return {
        customerContact: state.customerContact.customer,
        isOpen: state.menu.currentlyOpenMenu === Menu.CustomerContactDetails,
        canAccessCharters: userCanAccessCharters(state.auth)
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: {}): CustomerContactDetailsDispatchProps {
    return {
        fetchCustomerContactDetails: () => dispatch(new FetchRequest(new CustomerContactDetailsRequest())),
        closeMenu: () => dispatch(new SetOpenMenu(undefined)),
        openAccountPreferencesMenu: () => dispatch(new SetOpenMenu(Menu.AccountPreferences))
    };
}

export const CustomerContactDetails = connectWithRequests(mapStateToProps, mapDispatchToProps)
    (CustomerContactDetailsPresentational);
